// extracted by mini-css-extract-plugin
export default {"cell":"tableSkeleton_cell__OhRLg","skeleton":"tableSkeleton_skeleton__-gLr8","shimmer":"tableSkeleton_shimmer__ESZMP","hideMobile":"tableSkeleton_hideMobile__dtK6U"};